// vue
import { useStore } from '@/store';

// hooks
import { useAxios } from '@/vue3/hooks/axiosHook';
import { GeoRecordImageData } from '../models';

export const useGeoRecordImageService = () => {
    const store = useStore();
    const { apiUrl } = store.state;
    const axios = useAxios();

    const getGeoRecordImages = async (geoRecord: any): Promise<any[]> => {
        let fd = new FormData();
        fd.append('json', JSON.stringify(geoRecord));

        const res = await axios.post(`${apiUrl}/geo-record/images-v2`, fd);

        return res.data;
    };

    const getGeoRecordImagesById = async (id: number): Promise<any> => {
        const res = await axios.get(`${apiUrl}/geo-record/images-v2/${id}`);

        return res.data;
    };

    const createGeoRecordImages = async (
        id: number,
        images: any,
    ): Promise<any> => {
        const res = await axios.post(
            `${apiUrl}/geo-record/images-v2/${id}`,
            images,
        );
        return res.data;
    };

    const deleteGeoRecordImage = async (
        geoRecordImageData: GeoRecordImageData,
    ): Promise<any> => {
        const res = await axios.deleteObject(
            `${apiUrl}/geo-record/images-v2/delete`,
            geoRecordImageData,
            10000,
        );
        return res.data;
    };

    return {
        getGeoRecordImages,
        createGeoRecordImages,
        deleteGeoRecordImage,
        getGeoRecordImagesById,
    };
};
